import ROS from '../components/RevealOnScroll';
import { useEffect, useState } from 'react';

export default function Contact({inverse = false, name = "",titul="", tel = "",mail = "",img = ""}) {
    const [isSmall, setIsSmall] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(min-width: 640px)');
        const handleChange = () => setIsSmall(!mediaQuery.matches);
        mediaQuery.addEventListener('change', handleChange);
        handleChange();
    }, []);

    var width = "calc( 50% + 320px )";
    var centerer= "";
    var l = "pl-2";
    if(isSmall){
        width = "100%";
        centerer = "text-center";
        l= "";
    }

    var Photo = <img className={"h-44 drop-shadow-xl/50 rounded-full mx-8 mt-4 border-solid border-4 border-orange-700 sm:m-5 "} src={img} alt="photo"/>;
    if(img === ""){
        Photo = "";
        centerer = "text-center";
    }
    

    var Contact = <div className={"content-center block p-6" + centerer}>
                    <h1 className="text-2xl font-bold fade-in-up">{name}</h1>
                    <h2 className="text-sm font-bold fade-in-up text-gray-700">{titul}</h2>
                    <div className={"pt-2 " +l}>
                        <p className="text-lg">Email: <a href={"mailto:" + mail} className={"font-bold hover:text-orange-700 text-orange-900 underline"}>{mail}</a> </p>
                        <p className="text-lg">Tel: <span className={"pl-3 font-bold text-orange-950 "}>{tel}</span></p>
                    </div>
                </div>;

    if(inverse && !isSmall){
        [Photo, Contact] = [Contact, Photo];
    }

    return (
        <ROS>
            <div className="lg:mx-24 mb-4 px-5 sm:flex justify-center">
                <div style={{width:width}} className=" sm:flex grid bg-opacity-95 block bg-white rounded-lg shadow-sm justify-center p-2 place-items-center">
                    {Photo}
                    {Contact}
                </div>
            </div>
        </ROS>
    )
}